(function () {
  'use strict';

  var PLACEHOLDER_SELECTOR = '[data-bioss-product-card-image]';
  var CARD_SELECTOR = '.products .box.product, .search-results .box.product, .collection .box.product';
  var MAX_CARDS_PER_SCAN = 120;
  var RESCAN_DELAY_MS = 150;
  var PERIODIC_RESCAN_MS = 2000;
  var PERIODIC_RESCAN_LIMIT_MS = 120000;
  var CACHE_VERSION = 'v353';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var startedAt = Date.now();
  var scanTimer = null;
  var imageObserver = null;
  var imageRequests = {};

  function normalizeText(text) {
    return (text || '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  }

  function normalizeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    url = url.trim()
      .replace(/\\\//g, '/')
      .replace(/\\u0026/g, '&')
      .replace(/^['\"]+|['\"]+$/g, '')
      .replace(/[}\]]+$/g, '')
      .trim();

    if (!url || url === 'null' || url === 'undefined') return '';
    if (/^https:\/\//i.test(url)) return url;
    if (/^http:\/\//i.test(url)) return url.replace(/^http:/i, 'https:');
    if (/^\/\//.test(url)) return window.location.protocol + url;
    if (/^\//.test(url)) return url;
    return 'https://' + url;
  }


  function cleanTargetName(title) {
    title = normalizeText(title || '');
    if (!title) return 'Antibody';
    title = title.split('|')[0].trim();
    title = title.replace(/\s+(Polyclonal|Monoclonal|Recombinant)\s+Antibody.*$/i, '');
    title = title.replace(/\s+Antibody.*$/i, '');
    title = title.replace(/\s+(Polyclonal|Monoclonal|Recombinant).*$/i, '');
    title = title.replace(/,.*$/, '');
    return normalizeText(title) || 'Antibody';
  }

  function skuFromProduct(productUrl, productTitle) {
    var text = (productTitle || '') + ' ' + (productUrl || '');
    var match = text.match(/\b(bs[mklhp]?|bsk[mhlp]?|ak|cs)-?\d+[a-z0-9-]*/i);
    if (!match) return 'this antibody';
    var sku = match[0];
    sku = sku.replace(/-?100ul.*$/i, '').replace(/-?20ul.*$/i, '');
    sku = sku.replace(/r\b/i, 'R').replace(/c\b/i, 'C').replace(/p\b/i, 'P');
    return sku;
  }

  function tissueFromImageText(text) {
    text = normalizeText(text || '');
    if (!text) return 'sample tissue';

    text = text.replace(/\.$/, '');
    text = text.replace(/^(IHC|IHC-P|IF|ICC|ICC\/IF|immunohistochemistry)\s*[:\-–]?\s*/i, '');
    text = text.replace(/\bstaining\b.*$/i, '').trim() || text;
    text = text.replace(/\b(tissue sections?|section|sample)\b/gi, 'tissue').trim();

    if (text.length > 42) {
      var speciesTissue = text.match(/\b(human|mouse|rat|rabbit|zebrafish|porcine|bovine)\b[^.,;:()]{0,28}/i);
      if (speciesTissue) text = normalizeText(speciesTissue[0]);
    }

    if (!/\btissue$/i.test(text)) text += ' tissue';
    return text;
  }

  function buildBiossCaption(image, productUrl, productTitle) {
    if (image && /bioss-unconjugated-antibody-vial|bioss-elisa-kit-representative|bioss-multiplex-ihc-kit-representative|bioss-conjugated-antibody-representative|bioss-hrp-polymer-kit-representative|bioss-ready-to-use-ihc-kit-representative/.test(image.src)) return image.alt;
    var target = cleanTargetName(productTitle);
    var sku = skuFromProduct(productUrl, productTitle);
    var tissue = tissueFromImageText((image && image.alt) || '');
    return target + ' staining with ' + sku + ' in ' + tissue + '.';
  }

  function pushImage(images, src, alt) {
    src = normalizeUrl(src);
    alt = normalizeText(alt);
    if (!src) return;

    for (var i = 0; i < images.length; i += 1) {
      if (images[i].src === src) return;
    }

    images.push({ src: src, alt: alt });
  }

  function extractImagesFromObject(value, images, fallbackAlt) {
    if (!value) return;

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i += 1) {
        extractImagesFromObject(value[i], images, fallbackAlt);
      }
      return;
    }

    if (typeof value === 'string') {
      extractImagesFromString(value, images, fallbackAlt);
      return;
    }

    if (typeof value !== 'object') return;

    var src = value.src || value.url || value.image_url || value.imageUrl || value.image || value.preview_image || value.original_src;
    if (src && typeof src === 'object') {
      src = src.src || src.url || src.image_url || src.original_src;
    }

    var alt = value.alt || value.description || value.title || fallbackAlt;
    pushImage(images, src, alt);

    if (value.images) extractImagesFromObject(value.images, images, fallbackAlt);
    if (value.files) extractImagesFromObject(value.files, images, fallbackAlt);
    if (value.value && value.value !== value) extractImagesFromObject(value.value, images, fallbackAlt);
  }

  function tryParseJsonString(text) {
    if (!text || typeof text !== 'string') return null;
    var cleaned = text.trim();
    if (!cleaned) return null;

    var candidates = [cleaned];
    candidates.push(cleaned.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&'));
    candidates.push(candidates[1].replace(/\\\//g, '/'));

    for (var i = 0; i < candidates.length; i += 1) {
      try {
        return JSON.parse(candidates[i]);
      } catch (error) {}
    }

    return null;
  }

  function extractImagesFromString(text, images, fallbackAlt) {
    if (!text || typeof text !== 'string') return;

    var parsed = tryParseJsonString(text);
    if (parsed) {
      extractImagesFromObject(parsed, images, fallbackAlt);
      if (images.length) return;
    }

    var decoded = text
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/\\\//g, '/');

    var objectPattern = /\{[^{}]*(?:image_url|imageUrl|src|url)[^{}]*\}/gi;
    var objectMatch;
    while ((objectMatch = objectPattern.exec(decoded)) !== null) {
      var objectText = objectMatch[0];
      var urlMatch = objectText.match(/(?:image_url|imageUrl|src|url)\s*[:=]\s*["']?([^"',}]+)["']?/i);
      var descMatch = objectText.match(/(?:description|alt|title)\s*[:=]\s*["']([^"']*)["']/i);
      if (urlMatch && urlMatch[1]) pushImage(images, urlMatch[1], descMatch && descMatch[1] ? descMatch[1] : fallbackAlt);
    }

    // Fallback for stringified metafields where the object regex fails.
    var directPattern = /(?:image_url|imageUrl|src|url)\s*[:=]\s*["']?((?:https?:)?\/\/[^"',}\s]+|cdn\.shopify\.com\/[^"',}\s]+|[^"',}\s]+\.(?:jpg|jpeg|png|gif|webp)(?:\?[^"',}\s]+)?)/gi;
    var directMatch;
    while ((directMatch = directPattern.exec(decoded)) !== null) {
      pushImage(images, directMatch[1], fallbackAlt);
    }
  }

  function getImagesFromPayload(payload, fallbackAlt) {
    var images = [];
    if (!payload) return images;

    extractImagesFromObject(payload.images, images, fallbackAlt);
    extractImagesFromObject(payload.raw, images, fallbackAlt);
    extractImagesFromObject(payload.metafield, images, fallbackAlt);
    extractImagesFromObject(payload.value, images, fallbackAlt);

    if (!images.length && typeof payload === 'string') {
      extractImagesFromString(payload, images, fallbackAlt);
    }

    extractImagesFromObject(payload.themeImage, images, fallbackAlt);
    extractImagesFromObject(payload.themeImages, images, fallbackAlt);

    return images;
  }

  function getInlineImagesFromSlot(slot, fallbackAlt) {
    var images = [];
    if (!slot) return images;

    extractImagesFromString(slot.getAttribute('data-inline-images'), images, fallbackAlt);
    extractImagesFromString(slot.getAttribute('data-inline-image-value'), images, fallbackAlt);

    var preloadedImages = slot.querySelector('[data-bioss-card-preloaded-images]');
    if (preloadedImages) extractImagesFromString(preloadedImages.textContent || '', images, fallbackAlt);

    var shopifyImages = slot.querySelector('[data-bioss-card-shopify-images]');
    if (shopifyImages) extractImagesFromString(shopifyImages.textContent || '', images, fallbackAlt);

    var currentImages = slot.querySelectorAll('.bioss-card-image-img, .bioss-card-image-carousel__image');
    if (currentImages && currentImages.length) {
      for (var i = 0; i < currentImages.length; i += 1) {
        pushImage(
          images,
          currentImages[i].getAttribute('src') || currentImages[i].src,
          currentImages[i].getAttribute('alt') || fallbackAlt
        );
      }
    }

    pushImage(
      images,
      slot.getAttribute('data-fallback-image-src'),
      slot.getAttribute('data-fallback-image-alt') || fallbackAlt
    );

    pushImage(images, slot.getAttribute('data-theme-image-src'), slot.getAttribute('data-theme-image-alt'));
    try {
      extractImagesFromObject(JSON.parse(slot.getAttribute('data-theme-images') || '[]'), images, fallbackAlt);
    } catch (error) {}

    return images;
  }

  function createButton(label, className) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute('aria-label', label === '‹' ? 'Previous product image' : 'Next product image');
    button.textContent = label;
    return button;
  }

  function getCardFigure(slot) {
    return slot && slot.closest ? slot.closest('figure') : null;
  }

  function getProductCard(slot) {
    return slot && slot.closest ? slot.closest('.box.product, .product-card') : null;
  }

  function markCardHasImages(slot) {
    var figure = getCardFigure(slot);
    var card = getProductCard(slot);

    if (figure && figure.classList) {
      figure.classList.add('has-bioss-card-images');
      figure.classList.remove('no-bioss-card-images');
    }

    if (card && card.classList) {
      card.classList.add('has-bioss-card-images');
      card.classList.remove('no-bioss-card-images');
    }
  }

  function markCardNoImages(slot) {
    var figure = getCardFigure(slot);
    var card = getProductCard(slot);

    if (figure && figure.classList) {
      figure.classList.add('no-bioss-card-images');
      figure.classList.remove('has-bioss-card-images');
    }

    if (card && card.classList) {
      card.classList.add('no-bioss-card-images');
      card.classList.remove('has-bioss-card-images');
    }
  }

  function renderImageBlock(el, images, productUrl, productTitle) {
    images = (images || [])
      .map(function (image) {
        return {
          src: normalizeUrl(image && image.src),
          alt: normalizeText((image && image.alt) || productTitle || '')
        };
      })
      .filter(function (image) { return image.src; });

    if (el.biossPublicationProduct !== productImageViewUrl(productUrl)) {
      el.biossPublicationRecords = [];
      el.removeAttribute('data-bioss-active-publication');
    }
    var savedPublication = el.getAttribute('data-bioss-active-publication');
    function appendPublicationImages(records) {
      (records || []).forEach(function (record) {
        var key = window.BiossPublicationMedia && window.BiossPublicationMedia.imageKey;
        var duplicate = images.some(function (image) {
          return (image.publication && image.publication.id === record.id) ||
            (key ? key(image.src) === key(record.full) : image.src === record.full);
        });
        if (!duplicate) images.push({ src: record.full, alt: [record.label, record.title].filter(Boolean).join(' · '), publication: record });
      });
    }
    appendPublicationImages(el.biossPublicationRecords);

    if (!images.length) {
      el.classList.add('bioss-card-image-empty');
      markCardNoImages(el);
      return false;
    }

    var currentIndex = Math.max(0, images.findIndex(function (image) { return image.publication && image.publication.id === savedPublication; }));
    var frame = document.createElement('div');
    frame.className = 'bioss-card-image-frame';

    var link = document.createElement('a');
    link.className = 'bioss-card-image-link';
    link.href = productUrl || '#';

    var img = document.createElement('img');
    img.className = 'bioss-card-image-img';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = images[currentIndex].src;
    img.alt = images[currentIndex].alt;
    img.setAttribute('data-bioss-cart-image-src', images[0].src);

    var caption = document.createElement('div');
    caption.className = 'bioss-card-image-caption';
    caption.hidden = true;

    link.appendChild(img);
    frame.appendChild(link);

    var count;
    function updateImage(index) {
      currentIndex = (index + images.length) % images.length;
      var image = images[currentIndex];
      img.src = image.src;
      img.alt = image.alt;
      if (count) count.textContent = (currentIndex + 1) + ' / ' + images.length;
      caption.textContent = image.publication ? image.alt : buildBiossCaption(image, productUrl, productTitle);
      if (image.publication) el.setAttribute('data-bioss-active-publication', image.publication.id);
      else el.removeAttribute('data-bioss-active-publication');
      el.dispatchEvent(new CustomEvent('bioss:card-image-change', { bubbles: true, detail: { publication: image.publication || null } }));
    }
    function ensureControls() {
      if (count || images.length < 2) return;
      var prev = createButton('‹', 'bioss-card-image-nav bioss-card-image-prev');
      var next = createButton('›', 'bioss-card-image-nav bioss-card-image-next');
      count = document.createElement('span');
      count.className = 'bioss-card-image-count';

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        updateImage(currentIndex - 1);
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        updateImage(currentIndex + 1);
      });

      frame.appendChild(prev);
      frame.appendChild(next);
      frame.appendChild(count);
    }
    ensureControls();

    var pricing = el.querySelector('.bioss-card-variant-pricing');
    el.innerHTML = '';
    el.appendChild(frame);
    el.appendChild(caption);
    if (pricing) el.appendChild(pricing);
    el.classList.remove('bioss-card-image-empty');
    el.classList.add('has-bioss-card-image');
    el.setAttribute('data-bioss-cart-image-src', images[0].src);
    el.setAttribute('aria-hidden', 'false');
    markCardHasImages(el);

    var card = getProductCard(el);
    if (card) {
      card.setAttribute('data-bioss-cart-image-src', images[0].src);
    }

    el.BiossCardImageGallery = {
      productUrl: productUrl,
      resetPublications: function () {
        images = images.filter(function (image) { return !image.publication; });
        el.biossPublicationRecords = [];
        el.removeAttribute('data-bioss-active-publication');
        if (images.length) updateImage(0);
        else {
          img.removeAttribute('src');
          frame.hidden = true;
          el.dispatchEvent(new CustomEvent('bioss:card-image-change', { bubbles: true, detail: { publication: null } }));
        }
      },
      showPublications: function (records, selectFirst) {
        el.biossPublicationProduct = productImageViewUrl(productUrl);
        el.biossPublicationRecords = records;
        appendPublicationImages(records);
        ensureControls();
        var index = images.findIndex(function (image) { return image.publication; });
        if (selectFirst !== false && index >= 0) updateImage(index);
        else updateImage(currentIndex);
      }
    };
    updateImage(currentIndex);
    el.dispatchEvent(new CustomEvent('bioss:card-gallery-ready', { bubbles: true }));

    return true;
  }

  function getProductUrlFromCard(card) {
    var direct = card.getAttribute('data-product-url');
    if (direct && direct.indexOf('/products/') !== -1) return direct.split('#')[0];

    var link = card.querySelector('a.product-title[href], header a[href*="/products/"], h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]');
    if (!link) return null;

    var href = link.getAttribute('href') || '';
    if (!href || href.indexOf('/products/') === -1) return null;
    return href.split('#')[0];
  }

  function getProductTitleFromCard(card) {
    var title = card.getAttribute('data-product-title');
    if (title) return title;
    var titleEl = card.querySelector('a.product-title, header a[href*="/products/"], h1 a, h2 a, h3 a');
    return titleEl ? normalizeText(titleEl.textContent || titleEl.getAttribute('title') || '') : '';
  }

  function productImageViewUrl(productUrl) {
    if (!productUrl) return null;
    var match = productUrl.match(/\/products\/([^/?#]+)/i);
    if (!match || !match[1]) return null;
    return '/products/' + match[1] + '?view=card-images';
  }

  function previewAwareViewUrl(viewUrl) {
    if (!viewUrl || !window.location || !window.URLSearchParams) return viewUrl;
    var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!previewThemeId || /[?&]preview_theme_id=/.test(viewUrl)) return viewUrl;
    return viewUrl + (viewUrl.indexOf('?') === -1 ? '?' : '&') + 'preview_theme_id=' + encodeURIComponent(previewThemeId);
  }

  function cacheKey(viewUrl) {
    return viewUrl ? 'bioss:card-images:' + CACHE_VERSION + ':' + viewUrl : null;
  }

  function readCachedImages(viewUrl) {
    var key = cacheKey(viewUrl);
    if (!key || !window.localStorage) return null;

    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expires || parsed.expires < Date.now()) {
        window.localStorage.removeItem(key);
        return null;
      }
      if (Array.isArray(parsed.images) && parsed.images.length) return parsed.images;
      window.localStorage.removeItem(key);
      return null;
    } catch (error) {
      return null;
    }
  }

  function writeCachedImages(viewUrl, images) {
    var key = cacheKey(viewUrl);
    if (!key || !images || !images.length || !window.localStorage) return;

    try {
      window.localStorage.setItem(key, JSON.stringify({
        images: images,
        expires: Date.now() + CACHE_TTL_MS
      }));
    } catch (error) {}
  }

  function parseFlickityOptions(frame) {
    var raw = frame && frame.getAttribute('data-flickity-options');
    if (!raw) return {};

    try {
      return JSON.parse(raw);
    } catch (error) {
      return {};
    }
  }

  function initPrebuiltCarousel(slot) {
    if (!slot) return false;

    var frame = slot.querySelector('.bioss-card-image-carousel__frame');
    var cells = frame ? frame.querySelectorAll('.bioss-card-image-carousel__cell') : null;
    if (!frame || !cells || !cells.length) return false;

    slot.classList.remove('bioss-card-image-empty');
    slot.classList.add('has-bioss-card-image');
    slot.setAttribute('aria-hidden', 'false');
    markCardHasImages(slot);

    if (cells.length < 2 || !frame.classList.contains('js-flickity')) {
      slot.setAttribute('data-bioss-prebuilt-carousel', 'true');
      return true;
    }

    if (!window.Flickity) return false;

    var existingFlickity = null;
    if (typeof window.Flickity.data === 'function') {
      try {
        existingFlickity = window.Flickity.data(frame);
      } catch (error) {
        existingFlickity = null;
      }
    }

    if (!existingFlickity) {
      try {
        new window.Flickity(frame, parseFlickityOptions(frame));
      } catch (error) {
        return false;
      }
    }

    slot.setAttribute('data-bioss-prebuilt-carousel', 'true');
    return true;
  }

  function fetchImages(viewUrl, fallbackAlt) {
    if (!viewUrl || !window.fetch) return Promise.resolve([]);

    var cached = readCachedImages(viewUrl);
    if (cached) return Promise.resolve(cached);

    if (imageRequests[viewUrl]) return imageRequests[viewUrl];

    imageRequests[viewUrl] = window.fetch(viewUrl, {
      credentials: 'same-origin',
      cache: 'force-cache'
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.text();
      })
      .then(function (text) {
        if (!text) return [];
        var payload = null;
        try {
          payload = JSON.parse(text);
        } catch (error) {
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          if (start > -1 && end > start) {
            try { payload = JSON.parse(text.slice(start, end + 1)); } catch (e) {}
          }
        }
        var images = getImagesFromPayload(payload || text, fallbackAlt);
        if (images.length) writeCachedImages(viewUrl, images);
        return images;
      })
      .catch(function () { return []; });

    return imageRequests[viewUrl];
  }

  function findOrCreateImageSlot(card) {
    var existing = card.querySelector('.bioss-card-image-loader, .bioss-card-image-injected');
    if (existing) return existing;

    var figure = card.querySelector('figure') || card;
    var slot = document.createElement('div');
    slot.className = 'bioss-card-image-injected';
    slot.setAttribute('data-bioss-product-card-image', 'injected');
    slot.setAttribute('aria-hidden', 'true');

    figure.insertBefore(slot, figure.firstChild);
    return slot;
  }

  function loadSlot(slot, productUrl, productTitle) {
    if (!slot || slot.getAttribute('data-bioss-image-loaded') === 'true') return;
    slot.removeAttribute('data-bioss-image-queued');
    slot.setAttribute('data-bioss-image-loaded', 'true');

    var inlineImages = getInlineImagesFromSlot(slot, productTitle);
    if (inlineImages.length) {
      renderImageBlock(slot, inlineImages, productUrl, productTitle);
    } else if (initPrebuiltCarousel(slot)) {
      return;
    }

    var endpoint = previewAwareViewUrl(slot.getAttribute('data-images-endpoint') || productImageViewUrl(productUrl));
    if (!endpoint) {
      if (!inlineImages.length) {
        slot.classList.add('bioss-card-image-empty');
        markCardNoImages(slot);
      }
      return;
    }

    fetchImages(endpoint, productTitle).then(function (images) {
      var fetchedImages = images || [];
      var fetchedFirst = normalizeUrl(fetchedImages[0] && fetchedImages[0].src);
      var inlineFirst = normalizeUrl(inlineImages[0] && inlineImages[0].src);

      if (fetchedImages.length) {
        if (!inlineImages.length || fetchedImages.length > inlineImages.length || fetchedFirst !== inlineFirst) {
          renderImageBlock(slot, fetchedImages, productUrl, productTitle);
        }
        return;
      }

      if (!inlineImages.length) renderImageBlock(slot, fetchedImages, productUrl, productTitle);
    });
  }

  function getImageObserver() {
    if (!('IntersectionObserver' in window)) return null;
    if (imageObserver) return imageObserver;

    imageObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        var slot = entry.target;
        imageObserver.unobserve(slot);
        loadSlot(
          slot,
          slot.getAttribute('data-product-url'),
          slot.getAttribute('data-product-title') || ''
        );
      }
    }, {
      rootMargin: '900px 0px',
      threshold: 0.01
    });

    return imageObserver;
  }

  function queueSlotLoad(slot, productUrl, productTitle) {
    if (!slot || slot.getAttribute('data-bioss-image-loaded') === 'true') return;
    if (productUrl) slot.setAttribute('data-product-url', productUrl);
    if (productTitle) slot.setAttribute('data-product-title', productTitle);
    if (slot.getAttribute('data-bioss-image-queued') === 'true') return;

    // Slots without Liquid-rendered images are hidden by CSS, so IntersectionObserver
    // will never intersect them. Load those immediately and let the endpoint fill in.
    var hasRenderedImage = slot.querySelector && slot.querySelector('.bioss-card-image-img, .bioss-card-image-carousel__image');

    if (slot.classList.contains('has-bioss-card-image') && hasRenderedImage) {
      markCardHasImages(slot);
    }

    if (!slot.classList.contains('has-bioss-card-image') || !hasRenderedImage) {
      loadSlot(slot, productUrl, productTitle);
      return;
    }

    var observer = getImageObserver();
    if (!observer) {
      loadSlot(slot, productUrl, productTitle);
      return;
    }

    slot.setAttribute('data-bioss-image-queued', 'true');
    observer.observe(slot);
  }

  function processPlaceholderSlots() {
    var slots = document.querySelectorAll(PLACEHOLDER_SELECTOR);
    for (var i = 0; i < slots.length; i += 1) {
      var slot = slots[i];
      var productUrl = slot.getAttribute('data-product-url');
      var productTitle = slot.getAttribute('data-product-title') || '';
      queueSlotLoad(slot, productUrl, productTitle);
    }
  }

  function processRenderedProductCards() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    var processed = 0;

    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      if (!card || (card.classList && card.classList.contains('article'))) continue;
      if (card.getAttribute('data-bioss-card-image-scan') === 'true') continue;

      var productUrl = getProductUrlFromCard(card);
      if (!productUrl) continue;

      var productTitle = getProductTitleFromCard(card);
      var slot = findOrCreateImageSlot(card);
      card.setAttribute('data-bioss-card-image-scan', 'true');
      queueSlotLoad(slot, productUrl, productTitle);

      processed += 1;
      if (processed >= MAX_CARDS_PER_SCAN) break;
    }
  }

  function initProductCardImages() {
    processPlaceholderSlots();
    processRenderedProductCards();
  }
  window.BiossProductCardImages = {
    getImagesFromPayload: getImagesFromPayload,
    showPublications: function (slot, records, productUrl, productTitle, selectFirst) {
      if (slot.BiossCardImageGallery && productImageViewUrl(slot.BiossCardImageGallery.productUrl) === productImageViewUrl(productUrl)) {
        slot.BiossCardImageGallery.showPublications(records, selectFirst);
      } else {
        var existingUrl = slot.getAttribute('data-product-url') || '';
        var nativeImages = productImageViewUrl(existingUrl) === productImageViewUrl(productUrl) ? getInlineImagesFromSlot(slot, productTitle) : [];
        var prebuilt = slot.querySelector('.bioss-card-image-carousel__frame');
        if (prebuilt && window.Flickity && typeof window.Flickity.data === 'function') {
          var instance = window.Flickity.data(prebuilt);
          if (instance) instance.destroy();
        }
        slot.biossPublicationProduct = productImageViewUrl(productUrl);
        slot.biossPublicationRecords = records;
        if (records.length && selectFirst !== false) slot.setAttribute('data-bioss-active-publication', records[0].id);
        renderImageBlock(slot, nativeImages, productUrl, productTitle);
      }
    }
  };

  function scheduleScan() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      initProductCardImages();
    }, RESCAN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardImages);
  } else {
    initProductCardImages();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      scheduleScan();
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', scheduleScan);
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.searchspring-facets, .filter-menu, .collection-sidebar, .pagination')) {
      window.setTimeout(scheduleScan, 300);
      window.setTimeout(scheduleScan, 900);
      window.setTimeout(scheduleScan, 1800);
    }
  });

  var periodic = window.setInterval(function () {
    if (Date.now() - startedAt > PERIODIC_RESCAN_LIMIT_MS) {
      window.clearInterval(periodic);
      return;
    }
    initProductCardImages();
  }, PERIODIC_RESCAN_MS);
})();
